var Vendd = (function (Vendd) {
    'use strict';

    Vendd.DeliveryPoint = (function (DeliveryPoint) {

        DeliveryPoint.Messages = (function (Messages) {

            Messages.GetModel = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.GetModel', {});
            };
            Messages.GetModel.className = 'Vendd.DeliveryPoint.Messages.GetModel';

            Messages.GetModelSuccess = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.GetModelSuccess', data);
            };
            Messages.GetModelSuccess.className = 'Vendd.DeliveryPoint.Messages.GetModelSuccess';

            Messages.GetModelFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.GetModelFailed', response);
            };
            Messages.GetModelFailed.className = 'Vendd.DeliveryPoint.Messages.GetModelFailed';            

            return Messages;

        })(DeliveryPoint.Messages || {});

        return DeliveryPoint;

    })(Vendd.DeliveryPoint || {});

    return Vendd;

})(Vendd || {});